function lazyLoad($container) {
    var images = ($container || document).querySelectorAll('.lazy:not(.lazyLoaded):not(.lazyError)'),
        observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting && !!entry.target.dataset.src) {
                    observer.unobserve(entry.target);

                    entry.target.onload = function() {
                        entry.target.classList.add('lazyLoaded');
                    };

                    entry.target.onerror = function() {
                        entry.target.classList.add('lazyError');
                    };

                    entry.target.src = entry.target.dataset.src;
                }
            });
        });

    [].slice.call(images).forEach(function(image) {
        observer.observe(image);
    });
}

export default function observeImages($container) {
    if (!window.IntersectionObserver) {
        var script = document.createElement('script');

        script.async = true;
        script.onload = function(){
            lazyLoad($container);
        };
        script.src = '/jsscripts/polyfills/intersection-observer.js';
        document.getElementsByTagName('head')[0].appendChild(script);
    } else {
        lazyLoad($container);
    }
}
